import React from "react";
import type { DateRange } from "@/hooks/useDateRange";
import {
  SERVICES_CONTENT_GAP,
  SERVICES_INNER_MIN_HEIGHT,
} from "../services/constants";
import { OperationsTopCategoriesDonutCard } from "./OperationsTopCategoriesDonutCard";
import { OperationsUnderestimatedServicesCard } from "./OperationsUnderestimatedServicesCard";
import type { OperationsRequestsSectionData } from "./types";

interface OperationsRequestsSectionWidgetProps {
  data: OperationsRequestsSectionData;
  dateRange: DateRange;
  onExportCategories?: (format: "csv" | "xlsx") => void;
  onExportUnderestimated?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
  className?: string;
}

export const OperationsRequestsSectionWidget: React.FC<
  OperationsRequestsSectionWidgetProps
> = ({
  data,
  dateRange,
  onExportCategories,
  onExportUnderestimated,
  exportDisabled = false,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        width: "100%",
        maxWidth: "100%",
        flexDirection: "column",
        gap: SERVICES_CONTENT_GAP,
      }}
    >
      <div
        className="flex w-full max-w-full flex-col items-stretch xl:flex-row"
        style={{
          gap: SERVICES_CONTENT_GAP,
          minHeight: SERVICES_INNER_MIN_HEIGHT,
        }}
      >
        <OperationsTopCategoriesDonutCard
          segments={data.categorySegments}
          total={data.categoryTotal}
          dateRange={dateRange}
          onExport={onExportCategories}
          exportDisabled={exportDisabled}
        />
        <OperationsUnderestimatedServicesCard
          summary={data.underestimatedSummary}
          rows={data.underestimatedServices}
          onExport={onExportUnderestimated}
          exportDisabled={exportDisabled}
          className="min-h-0 min-w-0 flex-1"
        />
      </div>
    </div>
  );
};
